import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaHome,
  FaFileAlt,
  FaBell,
  FaEnvelope,
  FaCaretDown,
  FaUserCircle,
  FaSignOutAlt,
  FaQuoteLeft
} from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import "./Navbar.css";
import { AuthContext } from "../../AuthContext/Authcontext";
import logo from "../../images/Final-logo-SBS.png";

const Navbar = ({ onToggleSidebar }) => {
  const {userId, userName, userEmail, userRole, logout } = useContext(AuthContext);
    const [formData] = useState({ imageUrl: "" });
  const [notifications] = useState([]);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [emailNotifications] = useState([]);
  const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    onToggleSidebar(!collapsed);
  };
  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
      onToggleSidebar(true);
    }
  };
  const handleProfileClick = () => setShowDropdown(!showDropdown);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const toggleNotificationDropdown = () => {
    setShowNotificationDropdown(!showNotificationDropdown);
    setShowEmailNotificationDropdown(false);
  };

  const toggleEmailNotificationDropdown = () => {
    setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
    setShowNotificationDropdown(false);
  };
  // Format role to readable text (e.g., "s-manager" → "Sales Manager")
  const formatRole = (role) => {
    if (!role) return "Manager";
    switch (role.toLowerCase()) {
      case "s-manager":
        return "Sales Manager";
      case "manager":
        return "Quotation Manager";
      default:
        return role
          .split("-")
          .map((w) => w[0].toUpperCase() + w.slice(1))
          .join(" ");
    }
  };

  const panelTitle = `${formatRole(userRole)} Panel`;

   // Determine sidebar items dynamically based on role
  const sidebarItems = [
    { path: "/m-dashboard", icon: <FaHome />, text: "Dashboard" },
    
   
    ...(userRole === "s-manager"
      ? [
        { path: ["/sales-managerleads", "/managerleadforms"], icon: <FaFileAlt />, text: "Leads" },
          {
            path: ["/sales-manageroppleads"],
            icon: <FaFileAlt />,
            text: "Opportunity",
          },
          
        ]
      : userRole === "manager"
      ? [
        { path: ["/managerleads", "/managerleadforms"], icon: <FaFileAlt />, text: "Leads" },
          {
            path: ["/manageroppleads","/m-view-lead/","/m-regret-email/","/m-view-quotation","/m-view-sent-quotations/","/m-raw-mail/","/m-send-email/"],
            icon: <FaFileAlt />,
            text: "Opportunity",
          },
          
        ]
      : []),
       { path: ["/m-quotationpage", "/m-previewquotation/", "/m-opp-view-sent-quotations/"], icon: <FaQuoteLeft />, text: "Quotation" },
  ];

  const isActive = (itemPath) => {
    if (Array.isArray(itemPath)) {
      return itemPath.some((path) => location.pathname.startsWith(path));
    }
    return location.pathname.startsWith(itemPath);
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div className="admin-header-left">
          <div className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`} onClick={toggleSidebar}>
            <IoMenu className="toggle-icon" />
          </div>
          <div className="header-logo">
            <img src={logo} alt="Company Logo" className="logo-image" />
          </div>
        </div>

        {/* Panel Title */}
        <div className="admin-header-center">
          <h3 className="admin-title">{panelTitle}</h3>
        </div>

        {/* Profile Section */}
        <div className="admin-header-right">
          <div className="admin-nav-icon-container  "        
              onClick={toggleNotificationDropdown}
            >
              <FaBell className="admin-nav-icon" />
              {notifications?.length > 0 && (
                <span className="admin-nav-badge">{notifications.length}</span>
              )}
              {showNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Notifications</span>
                    <span className="notification-count">{notifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!notifications || notifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new notifications
                      </div>
                    ) : (
                      notifications.map((notification) => (
                        <div
                          key={notification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${notification.read ? "" : "unread"}`}>
                              {`${notification.name || ""} ${notification.message || ""}`.slice(0, 40)}
                              {(notification.name?.length || 0) + (notification.message?.length || 0) > 40 ? "..." : ""}
                            </div>
                            <div className="notification-time">
                              {new Date(notification.createdAt).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {notifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      Mark all as read
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className="admin-nav-icon-container"
              onClick={toggleEmailNotificationDropdown}
            >
              <FaEnvelope className="admin-nav-icon" />
              {emailNotifications?.length > 0 && (
                <span className="admin-nav-badge">{emailNotifications.length}</span>
              )}
              {showEmailNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Messages</span>
                    <span className="notification-count">{emailNotifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!emailNotifications || emailNotifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new messages
                      </div>
                    ) : (
                      emailNotifications.map((emailnotification) => (
                        <div
                          key={emailnotification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${emailnotification.read ? "" : "unread"}`}>
                              {emailnotification.text?.length > 40
                                ? `${emailnotification.text.slice(0, 40)}...`
                                : emailnotification.text}
                            </div>
                            <div className="notification-time">
                              {new Date(emailnotification.created_at).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {emailNotifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      View all messages
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="divider"></div>
            <div
              className="admin-nav-icon-container profile-container"
              onClick={handleProfileClick}
            >
            <div className="admin-nav-profile">
               {formData.imageUrl ? (
                  <img
                    src={formData.imageUrl}
                    alt="Profile"
                    className="admin-nav-profile-img"
                  />
                ) : (
              <div className="profile-avatar">
                <FaUserCircle />
              </div>
   )}
                 <div className="profile-info">
                <span className="profile-name">{userName || "Manager User"}</span>
                <span className="profile-role">{formatRole(userRole)}</span>
              </div>
              <FaCaretDown className="admin-nav-caret-icon" />
            </div>
            {showDropdown && (
              <div className="admin-nav-profile-dropdown">
                <div className="admin-nav-profile-header">
                  <div className="profile-summary">
                    <div className="profile-dropdown-avatar">
                      <FaUserCircle />
                    </div>
                    <div>
                      <strong>{userName || "Manager User"}</strong>
                      <p>{userEmail || "No Email"}</p>
                    </div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                {/* <div className="admin-nav-profile-item" onClick={() => navigate("/profile")}>
                  <FaUserCircle className="dropdown-item-icon" /> Your Profile
                </div> */}
                <div className="admin-nav-profile-item" onClick={handleLogout}>
                  <FaSignOutAlt className="dropdown-item-icon" /> Sign Out
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-position-sticky">
          <ul className="nav flex-column">
            {sidebarItems.map((item) => (
              <li
                key={Array.isArray(item.path) ? item.path.join(",") : item.path}
                className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <Link className="nav-link" to={Array.isArray(item.path) ? item.path[0] : item.path}
                                  onClick={handleNavItemClick}

                >
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="link_text">{item.text}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
